<template>
  <div class="animated fadeIn">     
    <b-row>
      <b-col md="12">
         <!-- <b-breadcrumb :items="breadcrumbs"/>        -->
        <b-card>
          <div slot="header">
            <strong>Assign Access</strong>
             </div>
              <b-row>
             <b-col md="12" class="my-1" style="text-align: center; color:#20a8d8;">
                <h4>Please Select Pages For permission</h4>
              </b-col>
            </b-row>
            <b-form @submit.prevent="validateForm('form-1')" data-vv-scope="form-1">
            <b-row>
             <b-col md="4" class="my-1" >
              
                <input type='checkbox' @click='checkAll()' v-model='isCheckAll'> Check All
   

             <ul>
                <li v-for="(menus, index_main) in data">
                 <input type='checkbox' v-bind:value='menus' v-model='menusarr' @change='updateCheckall(menusarr,menus,index_main,$event)'>
                 {{ menus.title }}
                <ul v-if="menus.child">
                    <li  v-for="(item, index) in menus.child.length" >
                    <input type='checkbox' v-bind:value='menus.child[index]' v-model='allocatedMenu'  @change='updateCheckall1(menus.child[index],$event,menus.title,menus)'>
                     {{menus.child[index].title}} 
                   </li>
               </ul>
                </li>
             </ul>

              </b-col>
              <b-col md="2">
                <span class="btn btn-primary" title="Reset Access" @click="resetAccess()" >Reset</span> &nbsp;
                <span class="btn btn-danger" title="Clear Access" @click="clearAccess()" >Clear</span>
              </b-col>
              <b-col md="6" class="my-1" v-if="isquickuser == 'no'">
              
                      <b-form-group label="Select Default Page"  
                      :label-cols="3" >                   
                      <v-select id="mySelect" v-model="customer.defaultpage" :options="this.data2" name="defaultpage" v-validate="'required'" :class="{ danger: errors.has('defaultpage') }">
                      </v-select>
                         <b-input-group class="mb-3">
                        <span style="width:240px" v-show="errors.has('form-1.defaultpage')" class="help text-danger">{{ errors.first('form-1.defaultpage') }} Please Select Default Page</span>
                      </b-input-group>   
                    </b-form-group> 

              </b-col>
            </b-row>
           
              <b-row  style="float:left;">
               <b-col md="12" class="my-1">
            <button class="btn btn-lg btn-primary "  type="submit" >Save</button>
          </b-col>
          </b-row>
           </b-form>
          

         
         
               
     

       

        </b-card>
       
      </b-col>
    </b-row>
  </div>
</template>

<script>
import CONSTANTS from '@/utils/constants'
import Utils from '@/utils'
import Vue from 'vue'
export default {
  name: 'access', 
  data: function() {
    return {
      name: 'access',
      isBusy: false,
      customer: {},
      breadcrumbs: [{
        text: 'Dashboard',
        href: '/dashboard'
      },{
        text: 'Assign Access',
        active: true
      }],
    
     isCheckAll: false,
    data: [],
    menusarr: [],
    data2: ['dashboard_adv','dashboard_mr','dayclosureuser','approvepayment','consignmentallocationpickup','misreport_adv','codReports',
    'shipmentlocationtrack'],
    menusarr1: [],
    id:'',
    allocatedMenu :[],
    isquickuser:"",
     
        
    }
  },
  created: function() {
     console.log("INN", this.$route.query)
    this.isquickuser = this.$route.query.is_qwik_user

     // this.accessdata();
    this.displaydata();
    this.id = this.$route.params.id;

     //alert(this.id);
   
    
  },
  computed: {
  
    },
  methods: {
    accessdata: function(){

     // alert(" i m in");
       var userdata = localStorage.getItem('userData')
       var userInfo = JSON.parse(userdata) 

       var allocatedata=userInfo.body;
       // console.log(allocatedata);
    for (var key in allocatedata) {
           // console.log(allocatedata[key]);
         
           this.menusarr.push(allocatedata[key]);
        //   if(this.allocatedata[key].children)
        //   {
        //    this.menusarr1.push(allocatedata[key].children);
        // }
        } 
         this.customer.defaultpage=userInfo.defaultpage;
        //  console.log(this.menusarr1);
       },


      checkAll: function(){
       // alert(" i m in checkAll");

     this.isCheckAll = !this.isCheckAll;
      this.menusarr = [];
      this.menusarr1=[];
      this.allocatedMenu=[];
      if(this.isCheckAll)
      { // Check all
        
        // console.log( this.data);
        var allocatedata=[];
         allocatedata=this.data;
       
        for (var key in allocatedata) 
        {
           
          this.menusarr.push(allocatedata[key]);
         
          if(allocatedata[key].child && allocatedata[key].child.length >0)
          {
            for(var i_obj=0;i_obj<=allocatedata[key].child.length-1;i_obj++)
            {

              this.allocatedMenu.push(allocatedata[key].child[i_obj]); 
             
            }


          }
         
      }
      
    }else{
        this.menusarr = [];
        this.allocatedMenu=[];
        this.menusarr1=[];
        
      }
      // console.log(this.menusarr1);
    },
      validateForm(scope) {
      //alert(" i m in validation ");
    
      this.$validator.validateAll(scope).then(result => {
        if (result) { 
          //alert(" i m in alert");         
          this.updateaccess();
        }
      });
    },
    
    updateCheckall: function(menuarr,selected,index,event)
    {
      console.log("menuarr",menuarr);
      console.log("selected",selected);
      console.log("index",index);
     if(event.target.checked==true){
        
        var allocatedata=[];
         allocatedata=this.data;
         console.log("allocatedata",allocatedata);
       
        for (var key in allocatedata) 
        {
          
        if(key==index){
            // console.log("CheckInn");
       
        for(var i_obj=0;i_obj<=allocatedata[key].child.length-1;i_obj++)
            {

              this.allocatedMenu.push(allocatedata[key].child[i_obj]); 
             
            }


           }
           
           if(this.data.length==this.menusarr.length){
            // console.log("inn");
            this.isCheckAll=true;
           }
          
         
       
         
      }

       }else{
       
        var allocatedata=[];
        allocatedata=this.data;
        
        for (var key in this.allocatedMenu) 
        {
    
          if(selected.child[0].title==this.allocatedMenu[key].title){

            this.allocatedMenu.splice(key,selected.child.length)
          
          }
        }
        this.isCheckAll=false;
       } 
     
     // if(value.children)
     // {
     // this.menusarr1[indexval]=[];
     // }
     
     //  if(this.menusarr.length == this.data.length){
     //     this.isCheckAll = true;
     //  }else{
     //     this.isCheckAll = false;
     //  }
   
    },
  
  showCheckChildObject: function(menusarr,childTitle,parentObject)
  {
    //console.log(menusarr);
   
      var index = -1;
      var val = childTitle.title;

      var filteredObj = this.menusarr.find(function(item, i)
      {
      //console.log(item.child);
        
        if(item.title === parentObject)
        {
            index = i;

            var newarr = item.child;   


            
            if(newarr.length >0)
            {
              for(var i_chld=0;i_chld<=newarr.length-1;i_chld++)
              {
                  // console.log(newarr[i_chld].title,"<>",newarr.length);

                  switch(newarr[i_chld].title)
                  {
                    case 'Print Sticker' :

                      //alert("A");
                      return true;
                    break;
                    default:
                     //return false;
                    break;


                  }
 

              }

            }
            
            

          /* var filteredObjChild = this.newarr.find(function(itemChild, i)
            {

              if(itemChild.title==val)
              {
                return true;
              }
              else
              {
                return false;

              }

            }); */


          
          }    
          
      });



     /* if(childTitle.title=='Run Sheet')
      {
        return true;
      }
      else
      {
        return false;
      }*/
      

  },



  updateCheckall1: function(value,event,main_menu,parentMenu)
  {
      //console.log("==AADA==")
      //console.log(this.menusarr);

      //console.log("Main : ",parentMenu);
      //console.log("Sub :",value);

      var parentIndex = -1;
      var val = main_menu;


      //var index_of_object = this.menusarr.indexOf(main_menu);

      //alert(index_of_object);

      /***** FindOut parentIndex *****/
      var filteredObj = this.menusarr.find(function(item, i)
      {
        //alert(item.title +"==="+ val);

        if(item.title === val)  // Parent Match
        {
          parentIndex = i;

         
          return i;
        }

      });
       /***** FindOut parentIndex *****/
         //console.log("DT>>",parentIndex,filteredObj);  


         
      if(event.target.checked)  // Add New Object
      {
          if(parentIndex==-1) // Push new parent object & Child in it
          {
            
            //First Push Parent Object
            this.menusarr.push({"title":parentMenu.title,"href":parentMenu.href,"icon":parentMenu.icon,"child":[value]});


          }
          else // Push child object in existing
          {
            this.menusarr[parentIndex].child.push(value);

          }
         
      }
      else    // Remove Object
      {
          let childIndex =-1;
          this.parentObjArr=[];

          this.parentObjArr =this.menusarr[parentIndex].child ;



          if(this.parentObjArr.length >0)
          {
            for(var i_child=0;i_child<=this.parentObjArr.length-1;i_child++)
            {
               if(this.parentObjArr[i_child].title==value.title)
               {

                  this.menusarr[parentIndex].child.splice(i_child,'1');

                  // If No Child Exist ..then remove Parent Object

                  if(this.menusarr[parentIndex].child.length <=0)
                  {
                    this.menusarr.splice(parentIndex,'1');
                  }

               } 

            }

          } 

      }
      
      // console.log("Final >>",this.menusarr);
  },
    
    

  displaydata: function () 
  {
      var userdata = localStorage.getItem("userData");
      var userInfo = JSON.parse(userdata);

      this.allocatedMenu=[];

      let obj = {
        sysusermasterid:this.$route.params.id ,
        hub_id:`${userInfo.pickuplocationmasterid}`,
        is_qwik_user:this.isquickuser,
      }

      this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/menuaccesslisting`,obj)
      .then((result) => {
      if (result.body.returnmsg === 'Successful') 
      {
        this.data  = result.body.returnvalue[0].body;
         var allocatedata=[];
         allocatedata=result.body.user_aceess_listing[0].body;
       // console.log(allocatedata[0].children);
        
        for (var key in allocatedata) 
        {
          //console.log("ALLOCATEd  >>" ,allocatedata[key]);
         
          this.menusarr.push(allocatedata[key]);

          /***** By Prasad *****/

          // console.log("LN >>",allocatedata[key]);

          if(allocatedata[key].child && allocatedata[key].child.length >0)
          {
            for(var i_obj=0;i_obj<=allocatedata[key].child.length-1;i_obj++)
            {

              this.allocatedMenu.push(allocatedata[key].child[i_obj]);                
            }


          }
          else
          {
            this.allocatedMenu.push(allocatedata[key]);

          }

          /***** By Prasad *****/

           if(!allocatedata[key].child)
           {

           //alert("",allocatedata[key]);
           //  console.log(allocatedata[key]);

             this.menusarr1.push(allocatedata[key]);
               
           
            }
        // else
        // {
              //alert(allocatedata[key]);
        //   this.menusarr.push(allocatedata[key]);
        // }
      } 
      // console.log("Alloca >>",this.allocatedMenu);
      this.customer.defaultpage=result.body.user_aceess_listing[0].defaultpage;
      //  console.log(this.menusarr1);
        
      } 
      else 
      {
        this.data=[];

      }
      })
      .catch((ex) => {
      console.log('error-----', ex)
      })
  },
      

updateaccess: function () 
{
//alert("IM N");
        // console.log(this.customer.deliveryagentid.key);
        //alert(" i m in updateaccess");
      let userData = localStorage.getItem('userData');
      let userInfo = JSON.parse(userData);

      console.log("==Menu==");
      // console.log(this.menusarr)
if(this.menusarr.length>0){
       let obj = {
        sysusermasterid:this.id ,
        
          menubody: this.menusarr,
           defaultpage: this.customer.defaultpage,

      }
      console.log("Menu",obj);
      // return false;
      this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/updatemenuaccess`,obj)
        .then((result) => {
        if (result.body.returnmsg === 'Successful') {

          this.$fire({
              text: result.body.returnvalue,
              type: "success",
              timer: 2000
          });

          setTimeout(() => {

              if (this.id == userInfo.sysusermasterid) {

                  localStorage.removeItem('userData');
                  this.$router.push('/login');

              } else {

                  if (this.$route.query.is_qwik_user === 'yes') {
                      this.$router.push('/adminuser_mr/quick_dashboard');
                  } else {
                      this.$router.push('/adminuser_mr/normal');
                  }

              }

          }, 1000);
      }else {
            // alert(result.body.returnvalue);
            this.$fire({
                  text: result.body.returnvalue,
                  type: "error",
                  timer: 30000
                });
           // this.$router.push('/adminuser_mr');
          
          }
        })
        .catch((ex) => {
          console.log('error-----', ex)
        })
        }else{
         this.$fire({
                  text: "Please Assign Access to User",
                  type: "warning",
                  timer: 30000
                });
       }
    },
    resetAccess(){
      this.menusarr=[];
      this.allocatedMenu=[];
      this.menusarr1=[];
      this.isCheckAll=false;
      this.displaydata();
 },
 clearAccess(){
    this.menusarr=[];
    this.allocatedMenu=[];
    this.menusarr1=[];
    this.isCheckAll=false;
 },
    
 
    
  }
 
}
</script>
